import React, { useContext } from 'react';
import { ResizeContext } from '../../context/ResizeContext';

export default function ProjectsCard({myData}) {

  const { title, info, image, url, code, git } = myData;
  const sizeWindow = useContext(ResizeContext);

  return <>
    <div className='relative'>
      <img src={`../${image}`} alt={image} className='card rounded'/>
      <div className='gap-5 info--container'>
        <div className='d-flex flex-column info'>
          <h5>{title}</h5>
          <p>{info}</p>
          <span className='link--buttons'>
            <a href={url} target='_blank' rel='noreferrer' className='project--button'>
              {sizeWindow.width > 900 ? 'Explore' : <i className="bi bi-link-45deg link--icons proj--icons"></i>}
            </a>
            <a href={`https://github.com/dpdproject/${git}`} target='_blank' rel='noreferrer' className='project--button'>
            {sizeWindow.width > 900 ? 'Github' : <i className="bi bi-github link--icons proj--icons"></i>}
            </a>
          </span>
        </div>
        <ul>
          {code.map((e) => (
            <li>{e}</li>
          ))}
        </ul>
      </div>
    </div>
  </>
}
